export default "__VITE_ASSET__$c3RkKhK__"